import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { getPriceAfterCashbackIsApplied } from "@/components/ProductPage/mappers/price.mapper";
import { getCashbackPromotion } from "@/components/ProductPage/mappers/promotion.mapper";

import { CashbackContextProvider } from "./context/cashback.context";

type BaseProps = {};

const Base = ({ children }: RequireChildrenFor<BaseProps>) => {
    const { promotions, currentPrice } = useECommerceProduct();
    const cashbackPromotion = getCashbackPromotion(promotions);

    const cashbackAmount = cashbackPromotion?.cashbackAmount || null;
    const cashbackUnit = cashbackPromotion?.cashbackUnit || null;
    const priceAfterCashbackIsApplied = getPriceAfterCashbackIsApplied(
        currentPrice,
        cashbackPromotion
    );

    if (
        !cashbackPromotion?.cashbackAmount ||
        !cashbackPromotion?.cashbackUnit
    ) {
        return null;
    }

    return (
        <CashbackContextProvider
            cashbackAmount={cashbackAmount}
            cashbackUnit={cashbackUnit}
            priceAfterCashbackIsApplied={priceAfterCashbackIsApplied}
        >
            {children}
        </CashbackContextProvider>
    );
};

export { Base };
